/*
 * Messages exchanged between the "Attach as ZIP" dialog and the command that
 * opened it.
 *
 * A dialog has no access to Office.context.mailbox.item, so the finished
 * archive has to travel back to the command through messageParent - and that
 * channel takes only modest strings. The archive is therefore sent in chunks.
 *
 * The parent acknowledges each chunk with messageChild so the dialog can pace
 * itself. Hosts that don't support messageChild simply never ack: the dialog
 * detects that on chunk 0 and falls back to sending the rest unpaced.
 */

/** Characters per chunk. Comfortably below the smallest known host limit. */
export const CHUNK_SIZE = 24000;

/** How long the dialog waits for the very first ack before giving up on acks. */
export const ACK_PROBE_TIMEOUT_MS = 2500;

/** How long the dialog waits for later acks before treating the transfer as dead. */
export const ACK_TIMEOUT_MS = 20000;

export type ChildMessage =
  | { t: "begin"; name: string; total: number; length: number }
  | { t: "chunk"; i: number; d: string }
  | { t: "end"; total: number }
  | { t: "cancel" }
  | { t: "error"; message: string };

export type ParentMessage = { t: "ack"; i: number };

export function encode(message: ChildMessage | ParentMessage): string {
  return JSON.stringify(message);
}

export function decode<T>(raw: string): T | undefined {
  try {
    return JSON.parse(raw) as T;
  } catch {
    return undefined;
  }
}
